import { forwardRef } from 'react';
import type { InputHTMLAttributes } from 'react';

import { Input } from './Input';
import { Label } from './Label';

interface FormFieldProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: string | undefined;
  label: string;
}

export const FormField = forwardRef<HTMLInputElement, FormFieldProps>(
  ({ error, id, label, ...props }, ref) => {
    const inputId = id ?? props.name;
    const errorId = `${inputId}-error`;

    return (
      <div className="space-y-2">
        <Label htmlFor={inputId}>{label}</Label>
        <Input
          ref={ref}
          id={inputId}
          aria-describedby={error ? errorId : undefined}
          aria-invalid={Boolean(error)}
          {...props}
        />
        {error ? (
          <p id={errorId} className="text-sm text-danger">
            {error}
          </p>
        ) : null}
      </div>
    );
  },
);

FormField.displayName = 'FormField';
